<p-sidebar
  [(visible)]="showNotificationSidebar"
  position="right"
  [showCloseIcon]="false"
  [baseZIndex]="10000"

  (onHide)="onSidebarClosed()"
>
  <ng-template pTemplate="header">
  </ng-template>

  <ng-template pTemplate="content">
    <p-tabView class="notification-tab">
      <p-tabPanel header="Received" >
        <app-received-notifications-overview
          (viewDetailsRequested)="onViewDetailsRequested($event, false)"
          (viewConversation)="handleViewConversation($event)"
          [activeNotificationId]="activeNotificationId"
          [receivedNotifications]="true"
        >
        </app-received-notifications-overview>
      </p-tabPanel>
      <p-tabPanel *ngIf="createNotificationsVisible" header="Sent">
        <app-received-notifications-overview
          (viewDetailsRequested)="onViewDetailsRequested($event, true)"
          (viewConversation)="handleViewConversation($event)"
          [activeNotificationId]="activeNotificationId"
          [receivedNotifications]="false"
        >
        </app-received-notifications-overview>
      </p-tabPanel>
    </p-tabView>
  </ng-template>

  <ng-template pTemplate="footer"> </ng-template>
</p-sidebar>

<p-dialog *ngIf="showTicketPopup"
  [(visible)]="showTicketPopup"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '50vw', 'max-width': '700px' }"
  [showHeader]="false"
  (onHide)="closeTicketDetailsPopup()"
>
  <app-ticket-details
    *ngIf="selectedNotificationForPopup"
    [notification]="selectedNotificationForPopup"
    (closePopup)="closeTicketDetailsPopup()"
    (viewConversation)="handleViewConversation($event)"
  >
  </app-ticket-details>
</p-dialog>

<p-dialog
  [(visible)]="showEmailNotificationsPopup"
  [closable]="true"
  [draggable]="true"
  [resizable]="true"
  [modal]="true"
  header="Conversations"
  [style]="{ width: '70%', height: '80%' }"
  (onHide)="closeConversationPopup()"
>
  <app-ticket-emails *ngIf="selectedNotificationIdForEmails"
    [notificationId]="selectedNotificationIdForEmails"
  ></app-ticket-emails>
</p-dialog>
